import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { User, Calendar, Flag } from "lucide-react";
import { format } from "date-fns";
import ReactCountryFlag from "react-country-flag";
import DotsVerticalIcon from "../../../../../component/icons/dots-vertical";
import NewEditIcon from "../../../../../component/icons/action-edit-icon";
import NewEyeIcon from "../../../../../component/icons/action-eye-icon";
import NewCardIcon from "../../../../../component/icons/action-card-icon";
import { Link } from "react-router";
import Tooltip from "../../../../../component/ui/tooltip";
import EmployeeDirectoryAddUpdate from "../../../../organization/emplyee-directory/add-update";

export default function LeadCard({
  lead,
  onClick,
  colors,
  country,
  ProductList = [],
  DealStages = [],
  UsersList = [],
  SubProductList = [],
  fetchSubProducts = () => {},
  fetchPackages = () => {},
  BrandList = [],
  PackageList = [],
  onSuccess = () => {},
  onError = () => {},
}) {
  const [countryCode, setCountryCode] = useState("");
  const [editAccount, setEditAccount] = useState(false);
  const [Menu, showMenu] = useState(false);

  const editDeal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setEditAccount(true);
  };

  useEffect(() => {
    const getCountryCode =
      country?.find((cn) => cn?.country_name == lead?.country) ||
      country.find((cn) => cn?.country_code == lead?.country);
    if (getCountryCode) {
      setCountryCode(getCountryCode.country_code);
    } else {
      setCountryCode("");
    }
  }, []);

  return (
    <>
      <motion.div
        whileHover={{ scale: 1.01, y: 0 }}
        whileTap={{ scale: 0.99 }}
        className="flex p-4 rounded-lg border border-[#E1E4EA] bg-[#fff] transition-all duration-300 "
        style={{
          boxShadow: "0 0 2px 0 rgba(0, 0, 0, 0.10)",
        }}
      >
        <div className="space-y-4 w-full">
          {/* Header */}
          <div className="flex items-start justify-between">
            <div className="flex-1 min-w-0">
              <h4
                className={`font-bold text-slate-900 text-sm leading-tight truncate border-l-2  border-l-[${
                  colors?.color ? colors?.color : "#9D5FEF"
                }] p-2`}
                style={
                  colors?.color
                    ? { borderColor: colors?.color }
                    : { borderColor: "#9D5FEF" }
                }
              >
                {lead?.name}
              </h4>
            </div>

            <div className="flex gap-1  p-2 z-10">
              <div className="">
                <div
                  className="-mr-4 transition-all duration-300 hover:text-gray-500 relative cursor-pointer"
                  onClick={() => {
                    showMenu(!Menu);
                  }}
                >
                  <DotsVerticalIcon />

                  {Menu ? (
                    <div
                      className={`border border-white shadow-xl absolute right-0 flex cursor-pointer  ${
                        Menu ? "opacity-1" : "opacity-0"
                      }`}
                    >
                      <div className="d-flex align-items-center gap-1">
                        <div
                          className={`w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300 `}
                          onClick={(e) => {
                            editDeal(e);
                          }}
                        >
                          <div
                            className="flex"
                            style={{ color: "#FF9500" }}
                            onClick={() => {
                              showMenu(false);
                            }}
                          >
                            <NewEditIcon className="h-4.5 w-4.5" />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center gap-1">
                        <div
                          className={
                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                          }
                          onClick={() => onClick?.(lead)}
                        >
                          <div
                            className="flex"
                            style={{ color: "#007AFF" }}
                            onClick={() => {
                              showMenu(false);
                            }}
                          >
                            <NewEyeIcon className="h-4.5 w-4.5" />
                          </div>
                        </div>
                      </div>

                      {lead?.completeLead?.leadid ? (
                        <div className="d-flex align-items-center gap-1">
                          <Link
                            to={`/leads/leadDetail/${lead?.completeLead?.leadid}`}
                            className={
                              "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                            }
                          >
                            <div
                              className="flex"
                              style={{ color: "#34C759" }}
                              onClick={() => {
                                showMenu(false);
                              }}
                            >
                              <NewCardIcon className="h-4.5 w-4.5" />
                            </div>
                          </Link>
                        </div>
                      ) : lead?.completeLead?.userid ? (
                        <div className="d-flex align-items-center gap-1">
                          <Link
                            to={`/contacts/contact-details/${lead?.completeLead?.userid}`}
                            className={
                              "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                            }
                          >
                            <div
                              className="flex"
                              style={{ color: "#34C759" }}
                              onClick={() => {
                                showMenu(false);
                              }}
                            >
                              <NewCardIcon className="h-4.5 w-4.5" />
                            </div>
                          </Link>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          {/* Middle Info */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1">
              {countryCode ? (
                <ReactCountryFlag
                  countryCode={countryCode}
                  svg
                  className="w-8 h-8  overflow-hidden flex justify-center items-center  "
                  title={lead?.country}
                />
              ) : (
                <>
                  <Flag className="w-4 h-4 text-emerald-600" />
                  <span className="font-semibold text-sm text-slate-800">
                    {lead?.country ?? "-"}
                  </span>
                </>
              )}
            </div>

            {lead?.contact_name && (
              <div className="flex items-center gap-1">
                <User size={16} color="#a09c9c" strokeWidth={2.5} />
                <span className="text-sm text-slate-600 truncate max-w-20">
                  {lead?.contact_name ?? "-"}
                </span>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between pt-2 border-t border-slate-300">
            <div className="flex items-center gap-1">
              <Calendar size={20} color="#a09c9c" strokeWidth={2.5} />
              <span className="text-xs  font-medium leading-9">
                {lead.time ? format(new Date(lead?.time), "MMM d") : "-"}
              </span>
            </div>

            <div className="flex items-center gap-1 h-full">
              <div className="flex -space-x-2">
                {Array.isArray(lead?.assigned) && lead.assigned.length > 0 ? (
                  lead.assigned.map((user, index) => (
                    <Tooltip
                      key={index}
                      content={user?.name || "Unknown User"}
                      position="top center"
                    >
                      <div
                        className="w-6 h-6 rounded-full flex items-center justify-center shadow-sm border border-white cursor-pointer"
                        style={{
                          backgroundColor: colors?.color || "#9D5FEF",
                          zIndex: lead.assigned.length - index,
                        }}
                      >
                        <span className="text-xs font-bold text-white">
                          {user?.name ? (
                            user.name.charAt(0).toUpperCase()
                          ) : (
                            <User size={14} color="white" strokeWidth={2.5} />
                          )}
                        </span>
                      </div>
                    </Tooltip>
                  ))
                ) : (
                  <Tooltip content="Not Assigned" position="top center">
                    <div
                      className="w-6 h-6 rounded-full flex items-center justify-center shadow-sm"
                      style={{
                        backgroundColor: colors?.color || "#9D5FEF",
                      }}
                    >
                      <User size={16} color="white" strokeWidth={2.5} />
                    </div>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {editAccount && (
        <EmployeeDirectoryAddUpdate
          onClose={() => {
            setEditAccount(false);
          }}
          data={lead?.completeLead}
          tabIndex={0}
          onError={onError}
          onSubmit={onSuccess}
        />
      )}
    </>
  );
}
